module.exports = __webpack_public_path__ + "static/media/shape_Q.5f08a730.glb";